import { JWTAuth } from "../../../lib/js-apiclient"
import { AdvancedApiClient } from "../../../lib/js-apiclient/src/AdvancedApiClient";

export class ProductVariantMediaApiClient extends AdvancedApiClient {

    static entityType = "Media"

    constructor(token, vid, id) {
        super();

        this.setEntityType(ProductVariantMediaApiClient.entityType);

        if(id !== undefined && id !== null) {
            this.setRoute("/api/v1/product-variant/{vid}/media/{id}")
                .setRouteParam("vid", vid)
                .setRouteParam("id", id);
        } else {
            this.setRoute("/api/v1/product-variant/{vid}/media")
                .setRouteParam("vid", vid)
        }
        
        if(token !== undefined && token !== null) {
            this.appendAuthSchema(new JWTAuth(token))
        }
    }

}